// 切换方案对象
import { ScenarioView } from '@/views/scenario/scenarioView'

export default {
    computed: {
        scenario() {
            if (this.$store && this.$store.state) {
                return this.$store.state.scenario.currentScenario
            }
            return null
        }
    },
    // watch
    watch: {
        scenario: {
            immediate: false,
            handler(newV, oldV) {
                if (newV && newV !== 'unknown') {
                    this.$_scenarioChange(newV, oldV)
                }
            }
        }
    },
    methods: {
        $_scenarioChange() {},
        /**
         * @api
         * 获取当前方案的图层
         */
        async $_getCurrentScenario() {
            return ScenarioView.getLayers(this.scenario)
        }
    }
}
